'use client'

import useSessionScrollPositionEffect from 'hook/useSessionScrollPositionEffect'

const RecordSessionScrollPosition = () => {
  useSessionScrollPositionEffect()

  return null
}

export default RecordSessionScrollPosition
